import { Platform } from 'react-native';
import { useEffect } from 'react';

type ContainableNode = {
  contains?: (target: Node | null) => boolean;
} | null;

type OutsideAwareRef = {
  current: ContainableNode;
};

export function useWebClickOutside(
  refs: readonly OutsideAwareRef[],
  enabled: boolean,
  onOutside: () => void,
) {
  useEffect(() => {
    if (Platform.OS !== 'web' || !enabled) return;

    const handlePointerDown = (event: PointerEvent) => {
      const target = event.target as Node | null;
      const clickedInside = refs.some((ref) => {
        const node = ref.current;
        return node != null
          && typeof node.contains === 'function'
          && node.contains(target);
      });

      if (!clickedInside) {
        onOutside();
      }
    };

    document.addEventListener('pointerdown', handlePointerDown, true);
    return () => {
      document.removeEventListener('pointerdown', handlePointerDown, true);
    };
  }, [enabled, onOutside, refs]);
}
